// extracted by mini-css-extract-plugin
export var icon = "_b5-3";
export var subtitle = "_b5-2";
export var title = "_b5-1";
export var value = "_b5-0";